import {observer} from "mobx-react";
import React from "react";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {PaymentSubscriptionEntity} from "@dropDesk/domain/entities/payment_subscriptions/payment_subscription_entity";
import {ContentButtonTable} from "@dropDesk/presentation/pages/panel_adm/ui/painel_adm/payments_history/table/styled";


const InvoiceView = observer(
    ({
         payment,
         onClickDownloadInvoice,
         currentSubscription
     }: {
        payment: PaymentEntity,
        onClickDownloadInvoice: (payment: PaymentEntity) => void
        currentSubscription: PaymentSubscriptionEntity
    }) => {
        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        const getContent = (payment: PaymentEntity): React.ReactNode => {
            if (!payment.canPay) {
                return (
                    <ContentButtonTable
                        onClick={() => onClickDownloadInvoice(payment)}
                        size={15}
                        color={colors.text}
                        background={colors.onBackground}
                        accent={colors.accent}
                    >
                        Abrir
                    </ContentButtonTable>
                )
            } else if (payment.isProcessingPaymentCreditCard && !currentSubscription.isCancelled) {
                return <span>Processando</span>
            } else {
                return null;
            }
        }

        return (
            <>
                {getContent(payment)}
            </>
        )
    })
export default InvoiceView;
